import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';
import { User } from '../../__generated__/graphql';

export const useUserMessageNames = () => {
  const { data: doctorList } = useQuery(
    graphql(`
      query usersListMessages {
        users {
          id
          name
          image
          title
          __typename
        }
      }
    `),
    { fetchPolicy: 'cache-first' },
  );

  const lookupUser = (userID?: string | null | undefined): User | null => {
    if (!userID) return null;

    return doctorList?.users?.find((a) => a?.id === userID) ?? null;
  };

  return { lookupUser };
};
